import { Controller } from "@hotwired/stimulus"
import { trackEvent } from "../utils/analytics"

export default class extends Controller {
  static values = { dismissUrl: String }

  connect() {
    if (!this.shouldShowPrompt()) return
    this.showModal()
  }

  shouldShowPrompt() {
    return (
      ("Notification" in window) && // browser support
      this.element.dataset.pushNotificationsEnabled === "true" && // feature flag
      this.element.dataset.userLoggedIn === "true" &&
      this.element.dataset.showPushNotificationPrompt === "true" && // just logged in
      !document.cookie.includes("pushNotificationPromptShown=true") && // not shown
      Notification.permission === "default" // not granted/reset
    )
  }

  showModal() {
    if (!window.Swal) return
    document.cookie = "pushNotificationPromptShown=true; path=/; SameSite=Lax"
    trackEvent("push_permission_prompt_shown", { source: "login_prompt" })
    window.Swal.fire({
      title: "Enable push notifications?",
      html: "Get notifications about assignments, grades, announcements, and other important updates from Aquifer.",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Opt in",
      confirmButtonAriaLabel: "Opt in to push notifications",
      denyButtonText: "Not now",
      denyButtonAriaLabel: "Dismiss push notifications prompt",
      customClass: {
        confirmButton: 'aq-button-2 medium with-margin',
        denyButton: 'aq-button-2 medium with-margin outline black',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.optIn()
      } else if (result.isDenied) {
        trackEvent("push_permission_dismissed", { source: "login_prompt" })
        this.dismiss()
      }
    })
  }

  async optIn() {
    try {
      const permission = await Notification.requestPermission()
      if (permission === "granted") {
        trackEvent("push_permission_granted", { source: "login_prompt" })
        localStorage.setItem("pendingPushSubscription", "true")
      } else if (permission === "denied") {
        trackEvent("push_permission_denied", { source: "login_prompt" })
      } else {
        trackEvent("push_permission_dismissed", { source: "login_prompt" })
      }
      await this.dismiss()
    } catch {
      await this.dismiss()
    }
  }

  async dismiss() {
    if (!this.hasDismissUrlValue) return
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    await fetch(this.dismissUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
  }
}
